import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "./context/GlobalContext";

const useAuthRedirect = () => {
  const navigate = useNavigate();
  const { globalState } = useContext(GlobalContext);

  useEffect(() => {
    if (globalState.loading) return;

    const { isSuperAdmin, isAuthenticated, needsProfileSetup, adminResolved } = globalState;
    const path = window.location.pathname;

    if (!isAuthenticated) {
      if (path !== "/") navigate("/");
    } else if (needsProfileSetup) {
      if (path !== "/profile-setup") navigate("/profile-setup");
    } else {
      if (path === "/" || path === "/profile-setup") {
        navigate("/home");
      } else if (path.startsWith("/admin") && adminResolved && !isSuperAdmin) {
        // Only bounce off an admin route once the super-admin check has
        // resolved, so a real admin isn't redirected mid-resolution.
        navigate("/home");
      }
    }
  }, [globalState, navigate]);
};

export default useAuthRedirect;
